import { View } from "@/components/ui/view";
import { CameraView } from 'expo-camera';
import React, { useEffect, useState } from 'react';
import { Alert, Platform } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import i18n from '@/assets/i18n';
import Footer from '@/components/basic/Footer';
import * as MediaSelector from '@/components/media/MediaSelector';
import { switchScreen } from '@/hooks/navigate';
import { backendRequest } from "@/stores/thunks";

const uuid = /[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/i

export default function ScanQRCode({ navigation }) {
    const user = useSelector((state) => state.user)
    const [scanned, setScanned] = useState(null);
    const dispatch = useDispatch()

    useEffect(() => {
        MediaSelector.requestPermissions()
        MediaSelector.ensureDirExists()
    }, [])

    const go2Task = (task, share, id) => {
        if (task) {
            navigation.popToTop()
            switchScreen(navigation, 'Workflows')
            switchScreen(navigation, 'ShowWorkflow2', { taskid: task.id, isLoading: false })
        } else {
            switchScreen(navigation, 'ModalRequestSent', { title: 'addContact.workflowShare', text: 'addContact.workflowShareText', options: { name: share.name }, back: 'Workflows' })
        }
    }

    const handleBarCodeScanned = ({ type, data }) => {
        setScanned(true)
        console.log('SCANNED', type, data)
        if (data.match(uuid)) {
            data = data.match(uuid)[0]
            if (data != user.id && data != '00000000-0000-0000-0000-000000000001') {
                dispatch(backendRequest('PROCESS_QRCODE_INLINE', '/qr/' + data, null, 'POST', false))
                    .then(json => {
                        if (json?.result) {
                            // console.log('QRCODE', json.result, json.workflows)
                            if (typeof json.result == 'string' || json.result.sharedWith) {
                                const task = json.workflows && json.workflows.find(workflow => workflow.workflowId == json.result.workflow.id)
                                go2Task(task, json.result, data)
                            } else {
                                const contacts = json
                                if (contacts.result != null) {
                                    const contact = contacts.active.find(contact => contact.toUser.id == data)
                                    switchScreen(navigation, 'ModalRequestSent', { title: 'addContact.contactAdd', text: 'addContact.contactAddText', options: { user: contact.toUser.mail }, back: 'ContactManagement' })
                                } else {
                                    switchScreen(navigation, 'ModalRequestSent', { title: 'addContact.contactFail', text: 'addContact.contactFailText', options: { user: data } })
                                }
                            }
                        } else {
                            Alert.alert(i18n.t('global.warning'), i18n.t('global.inValidQRCode'), [{ text: "OK", onPress: () => setScanned(false), }])
                        }
                    })
            } else {
                Alert.alert(i18n.t('global.warning'), i18n.t('global.ownQRCode'), [{ text: "OK", onPress: () => setScanned(false), }])
            }
        } else {
            Alert.alert(i18n.t('global.warning'), i18n.t('global.wrongQRCode'), [{ text: "OK", onPress: () => setScanned(false), }])
        }
    }

    const actionBack = () => {
        switchScreen(navigation, 'BACK')
    }

    return (
        <View className="flex-1">
            {!scanned && <CameraView
              style={{ flex: 1, aspectRatio: 1, marginBottom: Platform.select({ android: 0, ios: 40 }) }}
              onBarcodeScanned={scanned ? undefined : handleBarCodeScanned}
              barcodeScannerSettings={{
                  barcodeTypes: ["qr"],
                }}
            />}
            <Footer navigation={navigation} button={{ action: actionBack, info: 'addContact.cancel' }} />
        </View>
    );
}
